import angular from 'angular';
import taskFormModal from './taskFormModal';

export default angular
  .module('components.taskFormModal', [])
  .component('taskFormModal', taskFormModal).name;
